// Inject CSS into Recharge cart drawer shadow root (open)
(() => {
    const HOST_ID = "recharge-storefront-experiences__cart-drawer";
    const CSS = `
        #cart-drawer footer {
        display: flex;
        flex-direction: column;
        }
    `;

    function inject() {
        const host = document.getElementById(HOST_ID);
        if (!host) return false;

        const shadow = host.shadowRoot;
        if (!shadow) return false;

        // Avoid injecting multiple times
        if (shadow.querySelector('style[data-injected="cart-drawer-footer-flex"]')) return true;

        const style = document.createElement("style");
        style.setAttribute("data-injected", "cart-drawer-footer-flex");
        style.textContent = CSS;
        shadow.appendChild(style);

        return true;
    }

    // Try immediately
    if (inject()) return;

    // Observe DOM until the host + shadow are ready
    const obs = new MutationObserver(() => {
        if (inject()) obs.disconnect();
    });

    obs.observe(document.documentElement, {
        childList: true,
        subtree: true
    });

    // Optional safety timeout (prevents observer running forever)
    setTimeout(() => obs.disconnect(), 15000);
})();